module.exports = __webpack_public_path__ + "static/logo_h180-48d7dc0e156b984b56bd56cb8d05b2f2.png";